<template>
  <svg
    width="23"
    height="27"
    viewBox="0 0 23 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_40002730_3668"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="23"
      height="27"
    >
      <path
        d="M21.1397 26.0332H1.86029C0.832882 26.0332 0 25.2017 0 24.1761V1.89035C0 0.864675 0.832882 0.0332031 1.86029 0.0332031H14.375L23 8.64359V24.1761C23 25.2017 22.1671 26.0332 21.1397 26.0332Z"
        fill="url(#paint0_linear_40002730_3668)"
      />
    </mask>
    <g mask="url(#mask0_40002730_3668)">
      <path
        d="M21.1397 26.0332H1.86029C0.832882 26.0332 0 25.2017 0 24.1761V1.89035C0 0.864675 0.832882 0.0332031 1.86029 0.0332031H14.375L23 8.64359V24.1761C23 25.2017 22.1671 26.0332 21.1397 26.0332Z"
        fill="url(#paint1_linear_40002730_3668)"
      />
      <path
        d="M4.46628 15.3534H6.41028C6.73561 15.3534 7.03961 15.3854 7.32228 15.4494C7.60495 15.5081 7.85028 15.6094 8.05828 15.7534C8.26628 15.8974 8.42895 16.0894 8.54628 16.3294C8.66895 16.5641 8.73028 16.8574 8.73028 17.2094C8.73028 17.5454 8.66895 17.8388 8.54628 18.0894C8.42895 18.3348 8.26628 18.5374 8.05828 18.6974C7.85561 18.8574 7.61561 18.9774 7.33828 19.0574C7.06095 19.1321 6.76228 19.1694 6.44228 19.1694H5.65028V21.2734H4.46628V15.3534ZM6.36228 18.2334C7.16761 18.2334 7.57028 17.8921 7.57028 17.2094C7.57028 16.8628 7.46361 16.6228 7.25028 16.4894C7.04228 16.3561 6.73295 16.2894 6.32228 16.2894H5.65028V18.2334H6.36228ZM9.80222 15.3534H11.7462C12.0716 15.3534 12.3756 15.3854 12.6582 15.4494C12.9409 15.5081 13.1862 15.6094 13.3942 15.7534C13.6022 15.8974 13.7649 16.0894 13.8822 16.3294C14.0049 16.5641 14.0662 16.8574 14.0662 17.2094C14.0662 17.5454 14.0049 17.8388 13.8822 18.0894C13.7649 18.3348 13.6022 18.5374 13.3942 18.6974C13.1916 18.8574 12.9516 18.9774 12.6742 19.0574C12.3969 19.1321 12.0982 19.1694 11.7782 19.1694H10.9862V21.2734H9.80222V15.3534ZM11.6982 18.2334C12.5036 18.2334 12.9062 17.8921 12.9062 17.2094C12.9062 16.8628 12.7996 16.6228 12.5862 16.4894C12.3782 16.3561 12.0689 16.2894 11.6582 16.2894H10.9862V18.2334H11.6982ZM16.1657 16.3374H14.5017V15.3534H19.0297V16.3374H17.3497V21.2734H16.1657V16.3374Z"
        fill="white"
      />
      <g filter="url(#filter0_d_40002730_3668)">
        <path
          d="M23 8.64359H16.375C15.2704 8.64359 14.375 7.74816 14.375 6.64359V0.0332031L23 8.64359Z"
          fill="url(#paint2_linear_40002730_3668)"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_40002730_3668"
        x="-8.625"
        y="-23.9668"
        width="58.625"
        height="58.6104"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset
          dx="2"
          dy="1"
        />
        <feGaussianBlur stdDeviation="12.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.33 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_40002730_3668"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_40002730_3668"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_40002730_3668"
        x1="11.5"
        y1="0.0332031"
        x2="11.5"
        y2="26.0332"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF7979" />
        <stop
          offset="1"
          stop-color="#E85555"
        />
      </linearGradient>
      <linearGradient
        id="paint1_linear_40002730_3668"
        x1="11.5"
        y1="0.0332031"
        x2="11.5"
        y2="26.0332"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF8777" />
        <stop
          offset="1"
          stop-color="#F0695F"
        />
      </linearGradient>
      <linearGradient
        id="paint2_linear_40002730_3668"
        x1="18.6875"
        y1="0.0332031"
        x2="18.6875"
        y2="8.64359"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DA5D4C" />
        <stop
          offset="1"
          stop-color="#E32900"
        />
      </linearGradient>
    </defs>
  </svg>
</template>
